import { useMutation } from '@tanstack/react-query';
import axios from 'axios';
import {
	invalidateResourceRelationList,
	resourceRelationsQueryKeyFactory,
} from '.';
import { api } from '../../../../network';

export interface IDeleteResourceRelationArgs {
	onSuccess: () => void;
	onError: () => void;
}

export function useDeleteResourceRelation({
	onSuccess,
	onError,
}: IDeleteResourceRelationArgs) {
	const queryKey = resourceRelationsQueryKeyFactory.byArgs('delete_relation');

	const mutationFn = async ({
		fromEntityId,
		toEntityId,
	}: {
		fromEntityId: string;
		toEntityId: string;
	}) => {
		const { data } = await axios.delete(`${api()}lineage/relations`, {
			data: {
				from_entity: fromEntityId,
				to_entity: toEntityId,
			},
		});
		return data;
	};

	return useMutation({
		mutationKey: queryKey,
		mutationFn,
		onSuccess: (data, variables) => {
			invalidateResourceRelationList(variables.fromEntityId);
			invalidateResourceRelationList(variables.toEntityId);
			onSuccess();
		},
		onError,
	});
}
